module.exports = __webpack_public_path__ + "static/img/img_document@2x.35cb3182.png";